import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import NextImage from 'next/image';


const getBase64 = imagePath => fetch(imagePath)
  .then(response => response.blob())
  .then(blob => new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  }));

const Image = (props) => {
  const [blurredImage, setBlurredImage] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  const {
    hasInitialAnimation = false,
    layout = null,
    objectFit = null,
    objectPosition = null,
    priority = false,
    quality = 100,
    sizes = null,
    src = null,
    style = null,
    ...nextImageProps
  } = props;

  useEffect(() => {
    if (typeof src === 'string' && !hasInitialAnimation) {
      getBase64(src)
        .then((dataUrl) => {
          setBlurredImage(dataUrl);

          return dataUrl;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Translate the deprecated next/legacy/image props this component exposes onto the
  // modern next/image API: `layout="fill"` becomes the `fill` boolean, while `objectFit`
  // and `objectPosition` move into `style`. The legacy `lazyBoundary` prop has no modern
  // equivalent and is intentionally dropped in favour of native lazy-loading.
  const fillStyle = {
    ...(objectFit && { objectFit }),
    ...(objectPosition && { objectPosition }),
    ...style
  };

  // A `fill` image has no intrinsic width, so next/image needs `sizes` to pick the right
  // srcset candidate (otherwise it assumes 100vw and warns). Default fill images to 100vw
  // and let callers pass a more accurate value. Non-fill images keep using width/height.
  const isFill = layout === 'fill';
  const resolvedSizes = sizes || (isFill ? '100vw' : null);

  return (
    <NextImage
      {...(blurredImage && !imageLoaded && {
        blurDataURL: blurredImage,
        placeholder: 'blur'
      })}
      {...(isFill && { fill: true })}
      {...(resolvedSizes && { sizes: resolvedSizes })}
      {...(Object.keys(fillStyle).length > 0 && { style: fillStyle })}
      priority={priority}
      quality={quality}
      src={src}
      onLoad={() => {
        setImageLoaded(true);
      }}
      {...nextImageProps}
    />
  );
};

Image.propTypes = {
  hasInitialAnimation: PropTypes.bool,
  layout: PropTypes.oneOf(['fill']),
  objectFit: PropTypes.string,
  objectPosition: PropTypes.string,
  priority: PropTypes.bool,
  quality: PropTypes.number,
  sizes: PropTypes.string,
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  style: PropTypes.shape({})
};

export default Image;
